import React from 'react';

const ReplayButton = ({ interactiveRef }) => {
    return (
        <div className="z-50 flex flex-1 items-end mx-auto cursor-pointer">
            <button
                type="button"
                onClick={() => {
                    interactiveRef.current.replayPlayBackAnimation();
                }}
                className="flex justify-start items-center gap-[6px] pr-4 !bg-[#FF6200] text-white text-xs sm:text-sm font-bold tracking-[.12em]"
            >
                <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.8116 19.64L12.8516 15.62L14.5316 14L16.8116 16.34L19.2117 14L20.8916 15.68L16.8116 19.64Z"
                        fill="white"
                    />
                    <path
                        d="M15.73 13.88L16.8101 15.08L18.01 13.88V11.78V9.5H11.59H9.25V20.54H11.59V11.78H15.73V13.88Z"
                        fill="white"
                    />
                </svg>
                REPLAY
            </button>
        </div>
    );
};

export default ReplayButton;
